import React from 'react';
import { RadioButton, RadioButtonsGroupLayoutProps } from 'ui-builder';
import ShadcnBaseInputLayout from '../../layout/ShadcnBaseInputLayout';

function ShadcnRadioButtonsGroupLayout(props: RadioButtonsGroupLayoutProps<string | number>) {
  return (
    <ShadcnBaseInputLayout
      label={props.label}
      name={props.name}
      errors={props.errors}
      hint={props.hint}
      hideLabel={props.hideLabel}
      className={props.labelClassName}
    >
      <div className="flex flex-col gap-2">
        {props.options && props.options.map((option) => {
          return (
            <RadioButton
              key={`radio-button-option-value-${option.value}`}
              value={props.value === option.value}
              groupValue={option.value}
              isDisabled={option.disabled}
              label={option.label}
              source={props.name}
              onChangeCallback={() => {
                props.onChangeCallback!({
                  target: {
                    value: option.value,
                  },
                });
              }}
              hint={option.description}
              title={option.title}
            />
          );
        })}
      </div>
    </ShadcnBaseInputLayout>
  );
}

export default ShadcnRadioButtonsGroupLayout;
